// app/preset-utils.ts — слияние списков пресетов.

import type { SelectList, SmartTablePreset } from "../domain";

/**
 * Merge lists from default (seed) preset and active preset.
 * Active preset lists override default lists for the same propertyKey.
 * This ensures dropdowns work regardless of which preset is active.
 */
export function mergePresetLists(
  presets: SmartTablePreset[],
  activePresetId?: string,
): SelectList[] {
  const seedPreset = presets.find((p) => p.isSeed);
  const activePreset = activePresetId
    ? presets.find((p) => p.id === activePresetId)
    : undefined;
  const seedLists = seedPreset?.lists ?? [];
  const activeLists = activePreset?.lists ?? [];
  const byKey = new Map<string, SelectList>();
  for (const list of seedLists) {
    byKey.set(list.propertyKey, list);
  }
  for (const list of activeLists) {
    byKey.set(list.propertyKey, list);
  }
  return Array.from(byKey.values());
}
